import React from 'react';
import PreHeader from './components/PreHeader';
import Header from './components/Header';
import Hero from "./components/Hero";
import Screenshots from "./components/Screenshots";
import Why from "./components/Why";
import HowItWorks from "./components/HowItWorks";
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import './homePage.css';



function HomePage() {
  return (
    <>
      <PreHeader />
      <Header />
      <Hero />
      <Screenshots />
      <Why />
      <HowItWorks />
      <Pricing />
      <FAQ />
    </>
  );
}

export default HomePage;
